t = require('app/scripts/views/internal/teacup-with-helpers')('attachment_viewer_frame_details')

module.exports = ->
  t.div '.attachment-viewer-frame-details', ->

    t.h2 '.attachment-viewer-frame-details-title', ->
      t.text t.mustacheVar('name')

    t.p ->
      t.mustacheBlock 'date', ->
        t.format 'added', { date: t.mustacheVar('date') }
      t.mustacheBlock 'meta', ->
        t.text ' - '
        t.text t.mustacheVar('meta')

    t.p ->
      t.span '.js-meta', ->

        opts = { href: t.mustacheVar('url'), target: '_blank' }
        t.a opts, ->
          t.span { class: 'icon-sm icon-' + t.mustacheVar('openIconClass') + ' light attachment-viewer-option-icon' }
          t.text t.mustacheVar('openText')

        t.mustacheBlock '__ed', ->
          t.span { class: 'js-cover-options' + t.mustacheBlockInverted('canMakeCover', (-> ' hide')) }, ->

            t.span { class: 'js-make-cover-box' + t.mustacheBlock('isCover', (-> ' hide')) }, ->
              t.a '.js-make-cover', { href: '#' }, ->
                t.icon 'card-cover', { class: 'light attachment-viewer-option-icon' }
                t.format 'make-cover'

            t.span { class: 'js-remove-cover-box' + t.mustacheBlockInverted('isCover', (-> ' hide')) }, ->
              t.a '.js-remove-cover', { href: '#' }, ->
                t.icon 'card-cover', { class: 'light attachment-viewer-option-icon' }
                t.format 'remove-cover'

          t.a '.js-open-delete-confirm', { href: '#' }, ->
            t.icon 'close', { class: 'light attachment-viewer-option-icon' }
            t.text t.mustacheVar('removeButtonText')

      t.span '.js-confirm-delete.hide', ->
        t.text t.mustacheVar('removeMessageText')
        t.a '.attachment-viewer-delete-link.js-delete', { href: '#' }, ->
          t.text t.mustacheVar('removeConfirmText')
        t.a '.attachment-viewer-delete-link.js-close-delete-confirm', { href: '#' }, ->
          t.text t.mustacheVar('removeCancelText')
